// iOS 26 workaround: the viewport meta's device-width resolves to
// screen.width instead of the webview's visible width. Detect the
// mismatch and constrain the body via a CSS custom property.
//
// The property must be cleared once the mismatch is gone: on desktop a
// window that starts narrower than the screen and is then maximised would
// otherwise keep the body pinned to its old width until a reload.
export function updateAppWidth(): void {
  const iw = window.innerWidth;
  const root = document.documentElement;
  if (iw > 0 && iw < window.screen.width) {
    root.style.setProperty("--app-width", `${iw}px`);
  } else {
    root.style.removeProperty("--app-width");
  }
}
